import { notifyPdfLoadedSection } from '../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../PDFRenderer/PDFRendererTypes';

export const RECEIVE_DATA = 'P_BALANCESHEET.RECEIVE_DATA',
  SET_ERRORS = 'P_BALANCESHEET.SET_ERRORS',
  SET_CURRENT = 'P_BALANCESHEET.SET_CURRENT',
  SET_PROJECTED = 'P_BALANCESHEET.SET_PROJECTED',
  SET_YEAR = 'P_BALANCESHEET.SET_YEAR',
  SET_ERROR_TYPE = 'P_BALANCESHEET.SET_ERROR_TYPE';

export const receive_data = (resp_data, clientId) => ({
  type: RECEIVE_DATA,
  resp_data,
  clientId,
});

export const set_errors = (errors, clientId) => ({
  type: SET_ERRORS,
  errors,
  clientId,
});

export const set_error_type = (error_type, clientId) => ({
  type: SET_ERROR_TYPE,
  error_type,
  clientId,
});

export const set_current = (is_current, clientId) => ({
  type: SET_CURRENT,
  is_current,
  clientId,
});

export const set_projected = (is_projected, clientId) => ({
  type: SET_PROJECTED,
  is_projected,
  clientId,
});

export const set_year = (year, clientId) => ({
  type: SET_YEAR,
  year,
  clientId,
});

export const fetch_data = (IsCurrent, Owners, clientId, fpId, is_pdf, expandCurrentYear) => {
  if (!clientId) return {};
  return dispatch => {
    ADV.util
      .request(
        {
          uri: 'Consumer/ProjectedBalanceSheet',
          data: {
            IsCurrent,
            Owners,
            clientId,
            fpId,
            IsPdf: is_pdf,
            expandCurrentYear,
          },
          sendStringifyJSON: true,
          showSpinner: true,
        },
        true,
      )
      .then(resp => {
        if (resp.success) {
          dispatch(receive_data(resp.payload.viewData, clientId));
          dispatch(notifyPdfLoadedSection(PdfSectionType.ProjectedBalanceSheet));
        } else {
          dispatch(set_error_type(resp.errorType, clientId));
          dispatch(set_errors(resp.errors, clientId));
        }
      });
  };
};
